import { Container, Grid } from '@mui/material'
import { ChangeEvent, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import { getFavorites, unsetFavorite } from '@/redux/actions/favorites'
import { IRootState } from '@/redux/types'
import { FavoriteItem, IFavorite, TabInfo } from '../../models/favorites'
import FavoritesTabs from '../components/CustomTabs'
import FavoritesHeader from '../components/FavoritesHeader'
import FavoritesList from '../components/FavoritesList'
import { TABS_CONFIG } from '../components/TabInfo'

function Favorites() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { favorites } = useSelector((state: IRootState) => state.favorite)
  const [currentTab, setCurrentTab] = useState<number>(0)
  const [tmpFavorites, setTmpFavorites] = useState<IFavorite>({
    resources: [],
    courses: [],
    novelties: [],
    news: [],
    offers: [],
    catalogs: [],
    seminars: []
  })

  useEffect(() => {
    dispatch(getFavorites())
  }, [dispatch])

  useEffect(() => {
    setTmpFavorites(favorites)
  }, [favorites])

  useEffect(() => {
    Object.entries(tmpFavorites).some(([, value], index: number) => {
      if (value.length > 0) {
        setCurrentTab(index)
        return true
      }
      return false
    })
  }, [tmpFavorites])

  const handleChangeTab = (_: ChangeEvent<unknown>, newValue: number) => {
    setCurrentTab(newValue)
  }

  const redirectClick = (type: string, path: string, data: FavoriteItem) => {
    const basePath = `/${path}`
    if ('course' === type) {
      navigate(`${basePath}/${data.brand_id}/${data.slug}`)
    } else if ('novelty' === type) {
      navigate(`${basePath}/${data.slug}`)
    } else {
      navigate(`${basePath}/${data.id}`)
    }
  }

  const handleFavoriteClick = (id: number, type: string, indexPath: string) => (_: boolean) => {
    dispatch(
      unsetFavorite({
        id,
        type
      })
    )

    const tmpIndex = tmpFavorites[indexPath as keyof IFavorite].findIndex(value => value.id === id)
    const newFavorites = { ...tmpFavorites }
    newFavorites[indexPath as keyof IFavorite] = [
      ...tmpFavorites[indexPath as keyof IFavorite].slice(0, tmpIndex),
      ...tmpFavorites[indexPath as keyof IFavorite].slice(tmpIndex + 1)
    ]
    setTmpFavorites(newFavorites)
  }

  return (
    <>
      <FavoritesHeader />
      <Container maxWidth="lg" data-testid="favorites-client-container">
        <FavoritesTabs currentTab={currentTab} handleChangeTab={handleChangeTab} tmpFavorites={tmpFavorites} />
        <Grid container spacing={2}>
          {TABS_CONFIG.map((tab: TabInfo, index) => (
            <FavoritesList
              key={tab.key}
              data={tmpFavorites[tab.key]}
              resourceType={tab.resourceType}
              indexPath={tab.key}
              historyPath={tab.path}
              imgPath={tab.imagePath}
              currentTab={currentTab}
              index={index}
              onFavoriteClick={handleFavoriteClick}
              onRedirectClick={redirectClick}
            />
          ))}
        </Grid>
      </Container>
    </>
  )
}

export default Favorites
